import { FC } from "react";

import type { FinanceHistoryTab } from "../../model";

import styles from "./FinanceHistoryTabs.module.css";

interface FinanceHistoryTabsProps {
  active: FinanceHistoryTab;
  onChange: (tab: FinanceHistoryTab) => void;
}

export const FinanceHistoryTabs: FC<FinanceHistoryTabsProps> = ({
  active,
  onChange,
}) => (
  <div className={styles.tabs}>
    <button
      type="button"
      className={`${styles.tab} ${active === "deposits" ? styles.tabActive : ""}`}
      onClick={() => onChange("deposits")}
    >
      Deposits
    </button>
    <button
      type="button"
      className={`${styles.tab} ${active === "withdrawals" ? styles.tabActive : ""}`}
      onClick={() => onChange("withdrawals")}
    >
      Withdrawal
    </button>
  </div>
);
